import { useDispatch } from 'react-redux';
import Signin from '../sign-in/Signin';
import Styles from './AuthWindow.module.scss';
import { closeWindow } from '../../actions';
import { APP_KEY_IDS } from '../../constants/constants';
import classnames from "classnames"

const AuthWindow = () => {

  const dispatch = useDispatch()

  const removeIt = () =>{
      dispatch(closeWindow(APP_KEY_IDS.AUTH))
  }

  const preventClose = (e:any) => {
    e.stopPropagation()
  }

  return (
    <div className={Styles.container} onClick={removeIt} >
        <div className={classnames(Styles.auth_container,"glassBackground")} onClick={preventClose}>
            <Signin/>
        </div>
    </div>
  )
}

export default AuthWindow
